const apiUrl = process.env.REACT_APP_API_URL;
export const DeleteRol = async ( id : number , page : string, id_usu_log : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8071/usuaris/rol/${id_usu_log}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify({id})
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
